import { Injectable } from '@angular/core';
import { BaseBackend } from '@shared/apis/servers/base-backend';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpRequest } from '@angular/common/http';
import { timeout } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RsmEscalationBackendServer extends BaseBackend {

  getRsmEscalations(builder): Observable<any> {
    return this.get('/rsm-escalation', { params: builder });
  }

  getRsmEscalation(rsmEscalationNo): Observable<any> {
    return this.get(`/rsm-escalation/${ rsmEscalationNo }`);
  }

  createRsmEscalation(data): Observable<any> {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');

    const options = {
      headers,
      reportProgress: true,
    };

    // change post for progress bar
    const uploadReq = new HttpRequest('POST', `${ this.backend }/rsm-escalation`, data, options);
    return this.http.request(uploadReq).pipe(timeout(500000));
  }

  createExchangeTicket(data): Observable<any> {
    return this.post('/rsm-escalation/exchange-ticket', data);
  }

  updateRsmEscalationStatus(data): Observable<any> {
    const { rsmEscalationNo, status } = data;
    return this.patch(`/rsm-escalation/${ rsmEscalationNo }/${ status }`, data);
  }

  serverFileUpload(rsmEscalationNo, formData): Observable<any> {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');

    const options = {
      headers,
      reportProgress: true,
    };

    const uploadReq = new HttpRequest('PATCH', `${ this.backend }/rsm-escalation/${ rsmEscalationNo }/attachments/file`, formData, options);

    return this.http.request(uploadReq).pipe(timeout(500000));
  }

  deleteFile(params: any): Observable<any> {
    const { rsmEscalationNo } = params;
    return this.delete(`/rsm-escalation/${ rsmEscalationNo }/file`, { params });
  }

  getTicketInfoList(ticketNo, builder): Observable<any> {
    return this.get(`/rsm-escalation/${ ticketNo }/ticket-info`, { params: builder });
  }

  updateRsmEscalation(data) {
    const { rsmEscalationNo } = data;
    return this.patch(`/rsm-escalation/${ rsmEscalationNo }`, data);
  }

  updateRsmEscalationTicketAdd(data) {
    const { rsmEscalationNo } = data;
    return this.patch(`/rsm-escalation/${ rsmEscalationNo }/ticket-add`, data);
  }

  deletetTicketMapping(rsmEscalationNo, ticketNo) {
    return this.delete(`/rsm-escalation/${ rsmEscalationNo }/ticket/${ ticketNo }`);
  }
}
